export async function createAddress({
  name,
  email,
  phone,
  street,
  city,
  zip,
  state_id,
  country_id,
  csrf_token,
  submitted,
  partner_id,
  callback,
  field_required,
}) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  const urlencoded = new URLSearchParams();
  urlencoded.append("callback", callback || "");
  urlencoded.append("name", name);
  urlencoded.append("email", email);
  urlencoded.append("phone", phone);
  urlencoded.append("street", street);
  // urlencoded.append("street2", street2);
  urlencoded.append("city", city);
  urlencoded.append("zip", zip);
  urlencoded.append("state_id", state_id || "");
  urlencoded.append("country_id", country_id);
  urlencoded.append("csrf_token", csrf_token);
  urlencoded.append("submitted", submitted.toString());
  urlencoded.append("partner_id", partner_id.toString());
  urlencoded.append("field_required", field_required);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  try {
    const endpoint = "/shop/address";
    const fullUrl = `${window.location.origin}${endpoint}`;
    const res = await fetch(fullUrl, requestOptions);
    const text = await res.text();
    return text; // or parse and return as needed (e.g. JSON or DOM)
  } catch (error) {
    console.error("Error submitting address:", error);
    throw error;
  }
}
